import React from 'react';
import {Link} from 'react-router-dom';
import styles from './Button.module.css';

const Button = ({children, to, href, type = 'button', variant = 'primary', className = '', ...props}) => {
    const classNames = `${styles.button} ${styles[variant]} ${className}`.trim();

    if (to) {
        return <Link to={to} className={classNames} {...props}>{children}</Link>;
    }

    if (href) {
        return <a href={href} className={classNames} {...props}>{children}</a>;
    }

    return <button type={type} className={classNames} {...props}>{children}</button>;
};

export default Button;
